export default from './report-comment-modal';



// WEBPACK FOOTER //
// ./app/containers/report-comment-modal/index.js